export const PUBLIC_ROUTES = ['/login', '/logout']

export function isPublicRoute(pathname: string): boolean {
  return PUBLIC_ROUTES.includes(pathname)
}
